import PatientList from "../components/PatientList";

function PatientListPage() {
  return <PatientList />;
}

export default PatientListPage;
